import "./index.less";
import ProductForm from "../components/ProductEditForm";
export default function ProductCreate(props) {
  return (
    <ProductForm action="create" />
  );
}